import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {createForecastTaskMutation, CreateTaskInput} from './__generated__/createForecastTaskMutation.graphql';

// A deliberately minimal createTask for the ticketing "create + link" flow.
// Unlike web-front's board-coupled create_task_mutation.js (DraggableCard
// fragment + connection updaters), this only needs the new task's id so the
// caller can immediately link it to the ticket.
const mutation = graphql`
	mutation createForecastTaskMutation($input: CreateTaskInput!) {
		createTask(input: $input) {
			task {
				node {
					id
					companyTaskId
					name
				}
			}
			errors
		}
	}
`;

function commit(
	environment: Environment,
	input: CreateTaskInput,
	onCompleted?: (r: createForecastTaskMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<createForecastTaskMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'createForecastTaskMutation'};
